module.exports = __webpack_public_path__ + "c37308825d9a8412f3645d95771bf58a.jpg";